// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var OptionType;
(function (OptionType) {
    OptionType[OptionType["None"] = 0] = "None";
    OptionType[OptionType["Fake"] = 1] = "Fake";
    OptionType[OptionType["Real"] = 2] = "Real";
})(OptionType || (OptionType = {}));
